// Modal Labels
import { Routes } from "@lifeat/shared/system/RouteConstants";
import { firebase } from "@firebase-local/firebase";

export const MODAL_HEADER_SIGN_IN_LABEL = "Sign in";
export const MODAL_HEADER_SIGN_UP_LABEL = "Create account";
export const MODAL_HEADER_USER_SETTINGS_LABEL = "My account";
export const MODAL_BUTTON_ACCOUNT_LABEL = "My account";
export const USER_LOG_IN_BUTTON_LABEL = "Signup / Login";
export const CREATE_ACCOUNT_BUTTON_TEXT = "Sign up for free";
export const RESET_PASSWORD_BUTTON_LABEL = "Reset password";
export const USER_LOG_OUT_BUTTON_LABEL = "Log out";
export const USER_DELETE_BUTTON_LABEL = "Delete account";
export const DELETE_ACCOUNT_LINK = `/${Routes.DeleteAccountPage}`;
// User Settings Labels
export const USER_SETTINGS_LABELS = {
    DisplayName: "Name: ",
    UserEmail: "Email: ",
    OptInEmails: "Receive Marketing Emails and Announcements",
    OptInMetricsEmails: "Receive Daily Streak Email Notifications",
};
export const USER_ACCOUNT_MODAL_ERROR_MESSAGES = {
    UserSettingsUpdateError:
        "There was an error updating your settings. Please try again " + "later or contact support.",
    SignIn_EmailVerificationSent:
        "We just sent you a verification email. Click the link to complete " +
        "the signup process (please check your spam/junk if it's not in your inbox).\n\nYou can " +
        "ignore this message if you signed up with a Google account.",
    SignIn_EmailNotVerified: "Please verify your email to complete the sign up process.",
};
export const FIREBASE_NON_EMAIL_AUTH_PROVIDER_IDS = [firebase.auth.GoogleAuthProvider.PROVIDER_ID];
export const RESEND_VERIFICATION_EMAIL_BTN_LABEL = "Resend verification email";
export const MANAGE_PRO_SUBSCRIPTION_BTN_LABEL = "Subscription settings";
export const MANAGE_PRO_SUB_PAYMENT_METHODS_BTN_LABEL = "Change payment method";
export const MANAGE_BILLING_BTN_LABEL = "Manage billing";
export const CLEAR_MODAL_NOTIFICATIONS_DELAY = 10000; // 10 seconds
